import { Route, Routes } from "react-router-dom";
import FormacionDocente from "../newPages/homenew/FormacionDocente";
import MaestriaAnalisisBiologico from "../newPages/posgradosnew/MaestriaAnalisisBiologico";
import EspecializacionAnestesiologia from "../newPages/posgradosnew/EspecializacionAnestesiologia";
import EspecializacionImagenologia from "../newPages/posgradosnew/EspecializacionImagenologia";
import MaestriaGerenciaSalud from "../newPages/posgradosnew/MaestriaGerenciaSalud";
import MaestriaGestionCalidad from "../newPages/posgradosnew/MaestriaGestionCalidad";
import EspecializacionMedicina from "../newPages/posgradosnew/EspecializacionMedicina";
import PresencialHorarios from "../newPages/homenew/PresencialHorarios";
import PresencialResultados from "../newPages/homenew/PresencialResultados";
import MaestriaCienciasAmbientales from "../newPages/posgradosnew/MaestriaCienciasAmbientales";
import MaestriaProduccion from "../newPages/posgradosnew/MaestriaProduccion";

function NewRoutes() {
  return (
    <>
      <Routes>
        {" "}
        <Route
          path="/formacion-docente"
          element={<FormacionDocente></FormacionDocente>}
        />{" "}
        <Route
          path="/horarios-prueba-admision"
          element={<PresencialHorarios></PresencialHorarios>}
        />
        <Route
          path="/resultados-prueba-admision"
          element={<PresencialResultados />}
        />
        {/* Posgrados*/}
        <Route
          path="/maestria-analisis-biologico"
          element={<MaestriaAnalisisBiologico />}
        />
        <Route
          path="/maestria-gerencia-salud"
          element={<MaestriaGerenciaSalud />}
        />
        <Route
          path="/maestria-gestion-calidad"
          element={<MaestriaGestionCalidad />}
        />
           <Route
          path="/maestria-ciencias-ambientales"
          element={<MaestriaCienciasAmbientales />}
        />
            <Route
          path="/maestria-produccion"
          element={<MaestriaProduccion />}
        />
        <Route
          path="/especializacion-anestesiologia"
          element={<EspecializacionAnestesiologia />}
        />
        <Route
          path="/especializacion-imagenologia"
          element={<EspecializacionImagenologia />}
        />
        <Route
          path="/especializacion-medicina-familiar"
          element={<EspecializacionMedicina />}
        />
      </Routes>{" "}
    </>
  );
}

export default NewRoutes;
